import React from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import { Form } from "@carrotfertility/carotene-core-x"
import {
  useCheckRoutingInfoQueryCache,
  useUpdateRoutingInfo
} from "#/components/carrot-plans/shared/useQueryRoutingInfo"
import { defineMessage, FormattedMessage, useIntl } from "react-intl"
import {
  ButtonFooterLayout,
  ContinueButton,
  RoutingFlowTitle,
  StepLayout,
  useConvertTranslatedLabel
} from "#/components/carrot-plans/shared"
import { FormRadioButtonGroup } from "#/services/common-forms"
import { GoalTimeframe } from "#/components/carrot-plans/types/goalTimeframe"

const OPTIONS = [
  { label: defineMessage({ defaultMessage: "In the next few days" }), value: GoalTimeframe.NEXT_FEW_DAYS },
  { label: defineMessage({ defaultMessage: "In the next 30 days" }), value: GoalTimeframe.NEXT_30_DAYS },
  { label: defineMessage({ defaultMessage: "In the next 60 days" }), value: GoalTimeframe.NEXT_60_DAYS },
  {
    label: defineMessage({ defaultMessage: "Sometime after the next 60 days" }),
    value: GoalTimeframe.LONGER_TIMELINE
  }
]

export default function GoalTimeframeStep(): JSX.Element {
  const { mutateAsync } = useUpdateRoutingInfo()
  const routingData = useCheckRoutingInfoQueryCache()
  const defaultValue = routingData?.goalTimeframe
  const { send } = useStateMachine(defaultValue ? "" : null)
  const intl = useIntl()
  const radioOptions = useConvertTranslatedLabel(OPTIONS)

  async function onClickContinue(formValues: { goalTimeframe: string }): Promise<void> {
    await mutateAsync(formValues, { onSuccess: () => send("") })
  }

  const header = intl.formatMessage({
    defaultMessage: "How soon do you hope to accomplish the goal(s) you selected? Your best estimate is fine."
  })

  return (
    <>
      <RoutingFlowTitle title={header} />
      <StepLayout
        header={<span id="goalTimeframe-label">{header}</span>}
        formElements={
          <Form defaultValues={{ goalTimeframe: defaultValue }} onSubmit={onClickContinue}>
            <FormRadioButtonGroup
              controllerProps={{ rules: { required: intl.formatMessage({ defaultMessage: "Required" }) } }}
              aria-labelledby="goalTimeframe-label"
              name="goalTimeframe"
              options={radioOptions}
            />
            <ButtonFooterLayout
              continueButton={
                <ContinueButton>
                  <FormattedMessage defaultMessage="Continue" />
                </ContinueButton>
              }
            />
          </Form>
        }
      />
    </>
  )
}
